import React, { useEffect, useRef } from 'react';

const DetectivePathGenerator = () => {
  const iframeRef = useRef(null);

  useEffect(() => {
    // The HTML file is in the public/gen folder and served by the dev server
    // In production, it will be in the build folder
    const htmlPath = `${process.env.PUBLIC_URL}/gen/detective-path-generator.html`;

    if (iframeRef.current) {
      iframeRef.current.src = htmlPath;
    }
  }, []);

  return (
    <div style={{
      width: '100%',
      height: 'calc(100vh - 80px)',
      overflow: 'hidden'
    }}>
      <iframe
        ref={iframeRef}
        title="Detective Path Generator"
        style={{
          width: '100%',
          height: '100%',
          border: 'none'
        }}
      />
    </div>
  );
};

export default DetectivePathGenerator;
